import { ApiService } from './ApiService';
import apiResponse, { ApiResponse } from './ApiResponse';
import { Cookies } from 'react-cookie';
import { RawCommunicationPreference } from '@actions/SaveCommunicationPreferencesAction';

export class UserNotificationPreferencesStore {
  constructor(
    private readonly api: ApiService = new ApiService(),
    private readonly cookies: Cookies = new Cookies()
  ) {}

  public async delete(id: number) {
    const profile = this.cookies.get('profile');
    try {
      const response = await this.api.delete(`/user/${profile.id}/notification-preferences/${id}`);
      return apiResponse.Success<UserNotificationPreference>(response);
    } catch (e) {
      return apiResponse.HandleError(e);
    }
  }

  public async create(raw: RawCommunicationPreference[]) {
    const profile = this.cookies.get('profile');
    try {
      const response = await this.api.post(`/user/${profile.id}/notification-preferences`, raw);
      return apiResponse.Success<UserNotificationPreference>(response);
    } catch (e) {
      return apiResponse.HandleError(e);
    }
  }

  public async read(): Promise<ApiResponse<UserNotificationPreference[]>> {
    const profile = this.cookies.get('profile');
    try {
      const response = await this.api.get(`/user/${profile.id}/notification-preferences`);
      return apiResponse.Success<UserNotificationPreference[]>(response);
    } catch (e) {
      return apiResponse.HandleError(e);
    }
  }
}

export type UserNotificationPreference = {
  id: number;
  userId: number;
  notificationPreferenceId: number;
  notificationTypeId: number;
};
